// extracted by mini-css-extract-plugin
export default {"andMoreCTA":"trips-trip-byline-TripByLine__andMoreCTA--3uk9K","clickable":"trips-trip-byline-TripByLine__clickable--2ljnX","verified":"trips-trip-byline-TripByLine__verified--1Rufx"};